import player from './player'

const setCameraLookAt = function (eye, target, duration, callback) {
  let api = player.getApi()
  if (duration === null) duration = 2
  if (api) {
    api.setCameraLookAt(eye, target, duration, function () {
      if (callback != null) callback()
    })
  }
}

const getCamera = function () {
  let api = player.getApi()
  if (api) {
    api.getCameraLookAt(function (err, camera) {
      if (err) {
        console.log(err.stack)
      } else {
        console.log('View: {\n\t"eye": [%s,%s,%s],\n\t"lookat": [%s,%s,%s],\n}', camera.position[0].toFixed(2), camera.position[1].toFixed(2), camera.position[2].toFixed(2), camera.target[0].toFixed(2), camera.target[1].toFixed(2), camera.target[2].toFixed(2))
      }
    })
  }
}

window.configuratorapi.getCamera = getCamera

export default { setCameraLookAt, getCamera }
